import React, { useEffect, useState } from 'react';
import { colors } from '../../../../../styleSheet';
import {
  Typography,
  Box,
  Divider,
  LinearProgress,
  TableContainer,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Paper,
  TableBody,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import ServiceHeader from '../Node/ServiceHeader';
import { DrawerLoading, DrawerEmpty } from '../Node/DrawerStates';
import {
  progressTableContainerSx,
  progressTableSx,
  progressHeaderCellSx,
  progressBodyRowSx,
} from '../progressTableStyles';
import { matchesSearch } from '../taskSearch';
import TaskSearchField from '../TaskSearchField';

function ProgressInfo(props) {
  const { edge, getTasksProgress, tasksProgress, loadingTasksProgress } = props;
  const { session, date } = useParams();
  const [pendingFilter, setPendingFilter] = useState('');

  const visibleTasks = (tasksProgress ?? []).filter((task) =>
    matchesSearch(
      [
        task.body.aisle,
        task.body.job_id,
        task.create_time,
        task.schedule_time,
        task.dispatch_count,
      ],
      pendingFilter
    )
  );

  const header = (
    <ServiceHeader
      title={edge.data.child.cloud_tasks_queue}
      subtitle={`${edge.data.child.display_name ?? ''}${
        edge.data.child.description ? ` — ${edge.data.child.description}` : ''
      }`}
    />
  );

  const getProgress = () => {
    getTasksProgress({
      store: session.split('-')[1],
      session_id: session,
      queue_name: edge.data.child.cloud_tasks_queue,
      project_id: edge.data.child.queue_project_id,
      service_name: edge.data.child.service_name,
    });
  };
  useEffect(() => {
    getProgress();
  }, [session]);

  if (!tasksProgress && !loadingTasksProgress) {
    return (
      <Box>
        {header}
        <DrawerEmpty>Tasks progress not available...</DrawerEmpty>
      </Box>
    );
  }

  return (
    <Box>
      {header}
      {loadingTasksProgress ? (
        <DrawerLoading />
      ) : (
        <Box>
          <Typography
            sx={{
              marginX: 2,
              color: colors.lavender,
              fontWeight: 'bold',
              fontSize: 20,
            }}
          >
            Pending Tasks
          </Typography>
          {tasksProgress?.length > 0 ? (
            <Box>
              <TaskSearchField
                value={pendingFilter}
                onChange={(e) => setPendingFilter(e.target.value)}
              />
              {visibleTasks.length > 0 ? (
                <TableContainer component={Paper} sx={progressTableContainerSx}>
                  <Table
                    stickyHeader
                    aria-label="simple table"
                    sx={progressTableSx}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell sx={progressHeaderCellSx}>Aisle</TableCell>
                        <TableCell sx={progressHeaderCellSx}>Job ID </TableCell>

                        <TableCell sx={progressHeaderCellSx}>
                          Creation
                        </TableCell>
                        <TableCell sx={progressHeaderCellSx}>
                          Schedule Time
                        </TableCell>
                        <TableCell sx={progressHeaderCellSx}>Retries</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {visibleTasks.map((task, idx) => (
                        <TableRow key={idx} sx={progressBodyRowSx}>
                          <TableCell>{task.body.aisle}</TableCell>
                          <TableCell>{task.body.job_id}</TableCell>
                          <TableCell>{task.create_time}</TableCell>
                          <TableCell>{task.schedule_time}</TableCell>
                          <TableCell>{task.dispatch_count}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <DrawerEmpty>No tasks match your search...</DrawerEmpty>
              )}
            </Box>
          ) : (
            <DrawerEmpty>No pending tasks are scheduled...</DrawerEmpty>
          )}
        </Box>
      )}
    </Box>
  );
}

export default ProgressInfo;
